{
  "id": 11,
  "location": "cafe",
  "difficulty": "normal",
  "moves": 11,
  "kinds": 6,
  "goals": [
    { "type": "stain" }
  ],
  "stars": [1650, 2560],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . ~. ~. ~. ~. . .",
    ". . ~. ~. ~. ~. . .",
    ". . ~. ~. ~. ~. . .",
    ". . ~. ~. ~. ~. . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.837, "movesLeft": 4, "closeLosses": 0.158, "target": 0.88 }
}
